<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />

    <v-col lg="12" class="ml-auto"></v-col>

    <b-card
      v-if="$router.currentRoute.path == '/' + role + '/activeOrders'"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <template v-slot:header>
        <h6>استعلام‌های فعال</h6>
      </template>
      <loading v-if="vLoading" />
      <br />
      <b-tabs pills card vertical content-class="mr-3">
        <b-tab
          :title="'همه درخواست‌های فعال' + ' (' + orders.length + ')'"
          active
        >
          <b-card class="shadow mb-5 bg-white rounded">
            <v-row class="pe-4 ps-2 pb-0">
              <v-col cols="12" class="mt-3">
                <v-text-field
                  clearable
                  v-model="filter"
                  placeholder="جستجو"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col>
                <vue-excel-xlsx
                  class="darkGreen-mainBtn float-start"
                  style="width: 135px; height: 35px"
                  depressed
                  :data="orders"
                  :columns="ExcelFields"
                  :file-name="` همه درخواست‌های فعال`"
                  :sheet-name="`همه درخواست‌های فعال`"
                  :class="orders.length ? 'white--text' : 'disabled-excel'"
                  :style="orders.length ? '' : 'cursor:default'"
                >
                  <v-icon
                    :class="orders.length ? 'white--text' : ''"
                    class="me-1"
                  >
                    mdi-file-excel-outline
                  </v-icon>
                  خروجی اکسل</vue-excel-xlsx
                >
              </v-col>
              <v-col>
                <v-btn
                  :disabled="gettingReceipt || !orders.length"
                  class="darkRed-mainBtn white--text float-end"
                  style="width: 135px; height: 35px"
                  @click="printReceipt('ordersTable', 'همه درخواست های فعال')"
                  depressed
                  ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
                >
              </v-col>
            </v-row>
            <br />
            <b-table
              responsive
              show-empty
              id="allOrders-tabel"
              :items="orders"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(code)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="'/' + role + '/order/' + data.item.id"
                    target="_blank"
                    >{{ data.item.code }}</a
                  >
                  <span v-if="data.item.isUrgent" class="text-danger">
                    <i class="mr-1 fa fa-exclamation-triangle"> </i>
                    فوری
                  </span>
                </div>
              </template>
              <template v-slot:cell(customerName)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="
                      '/' + role + '/customerProfile/' + data.item.customerId
                    "
                    >{{ data.item.customerName }}</a
                  >
                </div>
              </template>

              <template v-slot:cell(operation)="row">
                <b-button
                  v-if="row.item._showDetails"
                  variant="danger"
                  @click="row.toggleDetails"
                  >بستن
                </b-button>
                <b-button v-else variant="primary" @click="row.toggleDetails"
                  >عملیات
                </b-button>
              </template>

              <template #row-details="row">
                <div
                  class="animated fadeIn"
                  style="text-align: center; vertical-align: middle"
                >
                  <a
                    class="btn btn-dark mr-1 mt-1"
                    :href="
                      '/' + role + '/printPreview/' + 'full/' + row.item.id
                    "
                    v-if="
                      row.item.status != 'ثبت استعلام' &&
                      row.item.status != 'اعلام تعیین قیمت به مشتری'
                    "
                    target="_blank"
                    role="button"
                    >نسخه چاپی</a
                  >

                  <b-btn
                    variant="success"
                    class="mr-1 mt-1"
                    v-if="row.item.status == 'اعلام تعیین قیمت به مشتری'"
                    @click="openModalCustomer(row.item)"
                    >ارسال تعیین قیمت به مشتری</b-btn
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' || role == 'Manager') &&
                      row.item.status == 'بررسی تعیین قیمت توسط مدیر فروش'
                    "
                    target="_blank"
                    role="button"
                    >بررسی تعیین قیمت</a
                  >
                  <b-btn
                    variant="danger"
                    class="mr-1 mt-1"
                    v-if="
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو' &&
                      (role == 'Manager' || role == 'salesManager')
                    "
                    @click="showRejectModal(row.item)"
                    >عدم</b-btn
                  >
                  <b-btn
                    variant="primary"
                    class="mr-1 mt-1"
                    @click="showModalFollow(row.item)"
                    >ثبت پیگیری</b-btn
                  >
                  <b-btn
                    class="mr-1 mt-1"
                    variant="success"
                    @click="assignToMe(row.item)"
                    v-if="
                      row.item.assigneeName == '-' &&
                      (role == 'Manager' || role == 'salesManager') &&
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو'
                    "
                    >تخصیص به من</b-btn
                  >&nbsp;
                  <b-btn
                    class="mr-1 mt-1"
                    variant="danger"
                    @click="removeAssignee(row.item)"
                    v-if="
                      row.item.assigneeName != '-' &&
                      role != 'secretary' &&
                      role != 'trade' &&
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو'
                    "
                    >حذف مجری</b-btn
                  >&nbsp;
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' ||
                        role == 'Manager' ||
                        role == 'ceo') &&
                      row.item.status == 'تعیین قیمت توسط مدیر عامل'
                    "
                    target="_blank"
                    role="button"
                    >تعیین قیمت</a
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      row.item.status == 'ثبت استعلام' &&
                      row.item.assigneeId == currentUserId
                    "
                    target="_blank"
                    role="button"
                    >ثبت استعلام</a
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' ||
                        role == 'Manager' ||
                        role == 'tradeHead') &&
                      row.item.status == 'در انتظار بررسی فنی'
                    "
                    target="_blank"
                    role="button"
                    >بررسی فنی</a
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'ceo' || role == 'Manager') &&
                      row.item.status == 'آماده برای امضا'
                    "
                    target="_blank"
                    role="button"
                    >بررسی نهایی و امضا</a
                  >
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>

            <b-pagination
              v-model="currentPage"
              :total-rows="orders.length"
              :per-page="perPage"
              aria-controls="allOrders-tabel"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-card>
        </b-tab>
        <b-tab
          :title="
            'استعلام‌های من' +
            ' (' +
            orders.filter((x) => x.assigneeName == userName).length +
            ')'
          "
        >
          <b-card class="shadow p-3 mb-5 bg-white rounded">
            <v-row class="p-0">
              <v-col cols="12" class="mt-3">
                <v-text-field
                  clearable
                  v-model="filter"
                  placeholder="جستجو"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col>
                <vue-excel-xlsx
                  style="width: 135px; height: 35px"
                  depressed
                  :disabled="
                    !orders.filter((x) => x.assigneeName == userName).length
                  "
                  class="darkGreen-mainBtn mb-3 float-start"
                  :class="
                    orders.filter((x) => x.assigneeName == userName).length
                      ? 'white--text'
                      : 'disabled-excel'
                  "
                  :data="orders.filter((x) => x.assigneeName == userName)"
                  :columns="ExcelFields"
                  :file-name="`استعلام‌های من`"
                  :style="
                    orders.filter((x) => x.assigneeName == userName).length
                      ? ''
                      : 'cursor:default'
                  "
                  :sheet-name="`استعلام‌های من`"
                >
                  <v-icon
                    class="me-1"
                    :class="
                      orders.filter((x) => x.assigneeName == userName).length
                        ? 'white--text'
                        : ''
                    "
                  >
                    mdi-file-excel-outline </v-icon
                  >خروجی اکسل
                </vue-excel-xlsx>
              </v-col>
              <v-col>
                <v-btn
                  :disabled="
                    gettingReceipt ||
                    !orders.filter((x) => x.assigneeName == userName).length
                  "
                  class="darkRed-mainBtn white--text float-end"
                  @click="printReceipt('myorders', 'درخواست‌های من')"
                  depressed
                  style="width: 135px; height: 35px"
                  ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
                >
              </v-col>
            </v-row>
            <br />
            <b-table
              show-empty
              id="allOrders-tabel"
              :items="orders.filter((x) => x.assigneeName == userName)"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(code)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="'/' + role + '/order/' + data.item.id"
                    target="_blank"
                    >{{ data.item.code }}</a
                  >
                  <span v-if="data.item.isUrgent" class="text-danger">
                    <i class="mr-1 fa fa-exclamation-triangle"> </i>
                    فوری
                  </span>
                </div>
              </template>
              <template v-slot:cell(customerName)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="
                      '/' + role + '/customerProfile/' + data.item.customerId
                    "
                    >{{ data.item.customerName }}</a
                  >
                </div>
              </template>

              <template v-slot:cell(operation)="row">
                <b-button
                  v-if="row.item._showDetails"
                  variant="danger"
                  @click="row.toggleDetails"
                  >بستن
                </b-button>
                <b-button v-else variant="primary" @click="row.toggleDetails"
                  >عملیات
                </b-button>
              </template>

              <template #row-details="row">
                <div
                  class="animated fadeIn"
                  style="text-align: center; vertical-align: middle"
                >
                  <a
                    class="btn btn-dark mr-1 mt-1"
                    :href="
                      '/' + role + '/printPreview/' + 'full/' + row.item.id
                    "
                    v-if="
                      row.item.status != 'ثبت استعلام' &&
                      row.item.status != 'اعلام تعیین قیمت به مشتری'
                    "
                    target="_blank"
                    role="button"
                    >نسخه چاپی</a
                  >
                  <b-btn
                    variant="success"
                    class="mr-1 mt-1"
                    v-if="row.item.status == 'اعلام تعیین قیمت به مشتری'"
                    @click="openModalCustomer(row.item)"
                    >ارسال تعیین قیمت به مشتری</b-btn
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' || role == 'Manager') &&
                      row.item.status == 'بررسی تعیین قیمت توسط مدیر فروش'
                    "
                    target="_blank"
                    role="button"
                    >بررسی تعیین قیمت</a
                  >
                  <b-btn
                    variant="danger"
                    class="mr-1 mt-1"
                    v-if="
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو' &&
                      (role == 'Manager' || role == 'salesManager')
                    "
                    @click="showRejectModal(row.item)"
                    >عدم</b-btn
                  >
                  <b-btn
                    variant="primary"
                    class="mr-1 mt-1"
                    @click="showModalFollow(row.item)"
                    >ثبت پیگیری</b-btn
                  >
                  <b-btn
                    class="mr-1 mt-1"
                    variant="success"
                    @click="assignToMe(row.item)"
                    v-if="
                      row.item.assigneeName == '-' &&
                      role != 'secretary' &&
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو'
                    "
                    >تخصیص به من</b-btn
                  >&nbsp;
                  <b-btn
                    class="mr-1 mt-1"
                    variant="danger"
                    @click="removeAssignee(row.item)"
                    v-if="
                      row.item.assigneeName != '-' &&
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو'
                    "
                    >حذف مجری</b-btn
                  >&nbsp;
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' ||
                        role == 'Manager' ||
                        role == 'ceo') &&
                      row.item.status == 'تعیین قیمت توسط مدیر عامل'
                    "
                    target="_blank"
                    role="button"
                    >تعیین قیمت</a
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      row.item.status == 'ثبت استعلام' &&
                      row.item.assigneeId == currentUserId
                    "
                    target="_blank"
                    role="button"
                    >ثبت استعلام</a
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' ||
                        role == 'Manager' ||
                        role == 'tradeHead') &&
                      row.item.status == 'در انتظار بررسی فنی'
                    "
                    target="_blank"
                    role="button"
                    >بررسی فنی</a
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'ceo' || role == 'Manager') &&
                      row.item.status == 'آماده برای امضا'
                    "
                    target="_blank"
                    role="button"
                    >بررسی نهایی و امضا</a
                  >
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>

            <b-pagination
              v-model="currentPage"
              :total-rows="
                orders.filter((x) => x.assigneeName == userName).length
              "
              :per-page="perPage"
              aria-controls="allOrders-tabel"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-card>
        </b-tab>
        <b-tab
          :title="
            'استعلام‌های ریویژن' +
            ' (' +
            orders.filter((x) => x.revision > 0).length +
            ')'
          "
        >
          <b-card class="shadow bg-white rounded">
            <v-row class="pe-4 ps-2 mt-3">
              <v-col cols="12">
                <v-text-field
                  clearable
                  v-model="filter"
                  placeholder="جستجو"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col>
                <vue-excel-xlsx
                  class="darkGreen-mainBtn float-start"
                  style="width: 135px; height: 35px"
                  depressed
                  :class="
                    orders.filter((x) => x.revision > 0).length
                      ? 'white--text'
                      : 'disabled-excel'
                  "
                  :data="orders.filter((x) => x.revision > 0)"
                  :columns="ExcelFields"
                  :file-name="`استعلام‌های ریویژن`"
                  :sheet-name="`استعلام‌های ریویژن`"
                  :style="
                    orders.filter((x) => x.revision > 0).length
                      ? ''
                      : 'cursor:default'
                  "
                >
                  <v-icon
                    class="me-1"
                    :class="
                      orders.filter((x) => x.revision > 0).length
                        ? 'white--text'
                        : ''
                    "
                  >
                    mdi-file-excel-outline
                  </v-icon>
                  خروجی اکسل
                </vue-excel-xlsx>
              </v-col>
              <v-col>
                <v-btn
                  :disabled="
                    gettingReceipt ||
                    !orders.filter((x) => x.revision > 0).length
                  "
                  class="darkRed-mainBtn white--text float-end"
                  @click="printReceipt('revisionOrders', 'درخواست‌های ریویژن ')"
                  depressed
                  style="width: 135px; height: 35px"
                  ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
                >
              </v-col>
            </v-row>
            <br />
            <b-table
              responsive
              show-empty
              id="allOrders-tabel"
              :items="orders.filter((x) => x.revision > 0)"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(code)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="'/' + role + '/order/' + data.item.id"
                    target="_blank"
                    >{{ data.item.code }}</a
                  >
                  <span v-if="data.item.isUrgent" class="text-danger">
                    <i class="mr-1 fa fa-exclamation-triangle"> </i>
                    فوری
                  </span>
                </div>
              </template>
              <template v-slot:cell(customerName)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="
                      '/' + role + '/customerProfile/' + data.item.customerId
                    "
                    >{{ data.item.customerName }}</a
                  >
                </div>
              </template>

              <template v-slot:cell(operation)="row">
                <b-button
                  v-if="row.item._showDetails"
                  variant="danger"
                  @click="row.toggleDetails"
                  >بستن
                </b-button>
                <b-button v-else variant="primary" @click="row.toggleDetails"
                  >عملیات
                </b-button>
              </template>

              <template #row-details="row">
                <div
                  class="animated fadeIn"
                  style="text-align: center; vertical-align: middle"
                >
                  <a
                    class="btn btn-dark mr-1 mt-1"
                    :href="
                      '/' + role + '/printPreview/' + 'full/' + row.item.id
                    "
                    v-if="
                      row.item.status != 'ثبت استعلام' &&
                      row.item.status != 'اعلام تعیین قیمت به مشتری'
                    "
                    target="_blank"
                    role="button"
                    >نسخه چاپی</a
                  >
                  <b-btn
                    variant="success"
                    class="mr-1 mt-1"
                    v-if="row.item.status == 'اعلام تعیین قیمت به مشتری'"
                    @click="openModalCustomer(row.item)"
                    >ارسال تعیین قیمت به مشتری</b-btn
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' || role == 'Manager') &&
                      row.item.status == 'بررسی تعیین قیمت توسط مدیر فروش'
                    "
                    target="_blank"
                    role="button"
                    >بررسی تعیین قیمت</a
                  >
                  <b-btn
                    variant="danger"
                    class="mr-1 mt-1"
                    v-if="
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو' &&
                      (role == 'Manager' || role == 'salesManager')
                    "
                    @click="showRejectModal(row.item)"
                    >عدم</b-btn
                  >
                  <b-btn
                    variant="primary"
                    class="mr-1 mt-1"
                    @click="showModalFollow(row.item)"
                    >ثبت پیگیری</b-btn
                  >
                  <b-btn
                    class="mr-1 mt-1"
                    variant="success"
                    @click="assignToMe(row.item)"
                    v-if="
                      row.item.assigneeName == '-' &&
                      role != 'secretary' &&
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو'
                    "
                    >تخصیص به من</b-btn
                  >&nbsp;
                  <b-btn
                    class="mr-1 mt-1"
                    variant="danger"
                    @click="removeAssignee(row.item)"
                    v-if="
                      row.item.assigneeName != '-' &&
                      role != 'secretary' &&
                      role != 'trade' &&
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو'
                    "
                    >حذف مجری</b-btn
                  >&nbsp;
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' ||
                        role == 'Manager' ||
                        role == 'ceo') &&
                      row.item.status == 'تعیین قیمت توسط مدیر عامل'
                    "
                    target="_blank"
                    role="button"
                    >تعیین قیمت</a
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      row.item.status == 'ثبت استعلام' &&
                      row.item.assigneeId == currentUserId
                    "
                    target="_blank"
                    role="button"
                    >ثبت استعلام</a
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' ||
                        role == 'Manager' ||
                        role == 'tradeHead') &&
                      row.item.status == 'در انتظار بررسی فنی'
                    "
                    target="_blank"
                    role="button"
                    >بررسی فنی</a
                  >
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'ceo' || role == 'Manager') &&
                      row.item.status == 'آماده برای امضا'
                    "
                    target="_blank"
                    role="button"
                    >بررسی نهایی و امضا</a
                  >
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>

            <b-pagination
              v-model="currentPage"
              :total-rows="orders.filter((x) => x.revision > 0).length"
              :per-page="perPage"
              aria-controls="allOrders-tabel"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-card>
        </b-tab>
        <b-tab
          v-for="(item, index) in statuses"
          :key="index"
          :title="
            item + ' (' + orders.filter((x) => x.status == item).length + ')'
          "
        >
          <b-card class="shadow mb-5 bg-white rounded">
            <v-row class="mb-3 pe-4 ps-2 pt-4">
              <v-col cols="12">
                <b-input-group size="md">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="جستجو"
                  ></b-form-input>
                  <b-input-group-append>
                    <v-btn
                      :disabled="!filter"
                      @click="filter = ''"
                      variant="danger"
                      >حذف</v-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </v-col>
              <v-col>
                <vue-excel-xlsx
                  class="darkGreen-mainBtn float-start"
                  style="width: 135px; height: 35px"
                  :class="
                    orders.filter((x) => x.status == item).length
                      ? 'white--text'
                      : 'disabled-excel'
                  "
                  :data="orders.filter((x) => x.status == item)"
                  :columns="ExcelFields"
                  :file-name="item"
                  :sheet-name="item"
                >
                  <v-icon
                    class="me-1"
                    :class="
                      orders.filter((x) => x.status == item).length
                        ? 'white--text'
                        : ''
                    "
                  >
                    mdi-file-excel-outline </v-icon
                  >خروجی اکسل
                </vue-excel-xlsx>
              </v-col>
              <v-col>
                <v-btn
                  :disabled="
                    gettingReceipt ||
                    !orders.filter((x) => x.status == item).length
                  "
                  class="darkRed-mainBtn white--text float-end"
                  @click="printReceipt('tabs', item)"
                  depressed
                  style="width: 135px; height: 35px"
                  ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
                >
              </v-col>
            </v-row>

            <b-table
              show-empty
              id="orderByStatus"
              :items="orders.filter((x) => x.status == item)"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy"
              :filter="filter"
              :filterIncludedFields="[
                'code',
                'requestId',
                'customerName',
                'assigneeName',
                'registerDate',
                'status',
              ]"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(code)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="'/' + role + '/order/' + data.item.id"
                    target="_blank"
                    >{{ data.item.code }}</a
                  >
                  <span v-if="data.item.isUrgent" class="text-danger">
                    <i class="mr-1 fa fa-exclamation-triangle"> </i>
                    فوری
                  </span>
                </div>
              </template>
              <template v-slot:cell(customerName)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="
                      '/' + role + '/customerProfile/' + data.item.customerId
                    "
                    >{{ data.item.customerName }}</a
                  >
                </div>
              </template>
              <template v-slot:cell(operation)="row">
                <b-button
                  v-if="row.item._showDetails"
                  variant="danger"
                  @click="row.toggleDetails"
                  >بستن
                </b-button>
                <b-button v-else variant="primary" @click="row.toggleDetails"
                  >عملیات
                </b-button>
              </template>

              <template #row-details="row">
                <div
                  class="animated fadeIn"
                  style="text-align: center; vertical-align: middle"
                >
                  <a
                    class="btn btn-dark mr-1 mt-1"
                    :href="
                      '/' + role + '/printPreview/' + 'full/' + row.item.id
                    "
                    v-if="
                      row.item.status != 'ثبت استعلام' &&
                      row.item.status != 'اعلام تعیین قیمت به مشتری'
                    "
                    target="_blank"
                    role="button"
                    >نسخه چاپی</a
                  >
                  <b-btn
                    variant="success"
                    class="mr-1 mt-1"
                    v-if="row.item.status == 'اعلام تعیین قیمت به مشتری'"
                    @click="openModalCustomer(row.item)"
                    >ارسال تعیین قیمت به مشتری</b-btn
                  >&nbsp;
                  <b-btn
                    variant="danger"
                    class="mr-1 mt-1"
                    v-if="
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو' &&
                      (role == 'Manager' || role == 'salesManager')
                    "
                    @click="showRejectModal(row.item)"
                    >عدم</b-btn
                  >&nbsp;
                  <b-btn
                    variant="primary"
                    class="mr-1 mt-1"
                    @click="showModalFollow(row.item)"
                    >ثبت پیگیری</b-btn
                  >&nbsp;
                  <b-btn
                    class="mr-1 mt-1"
                    variant="success"
                    @click="assignToMe(row.item)"
                    v-if="
                      row.item.assigneeName == '-' &&
                      role != 'secretary' &&
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو'
                    "
                    >تخصیص به من</b-btn
                  >&nbsp;
                  <b-btn
                    class="mr-1 mt-1"
                    variant="danger"
                    @click="removeAssignee(row.item)"
                    v-if="
                      row.item.assigneeName != '-' &&
                      role != 'secretary' &&
                      role != 'trade' &&
                      row.item.status != 'عدم' &&
                      row.item.status != 'آرشیو'
                    "
                    >حذف مجری</b-btn
                  >&nbsp;
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' || role == 'Manager') &&
                      row.item.status == 'بررسی تعیین قیمت توسط مدیر فروش'
                    "
                    target="_blank"
                    role="button"
                    >بررسی تعیین قیمت</a
                  >&nbsp;
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' ||
                        role == 'Manager' ||
                        role == 'ceo') &&
                      row.item.status == 'تعیین قیمت توسط مدیر عامل'
                    "
                    target="_blank"
                    role="button"
                    >تعیین قیمت</a
                  >&nbsp;
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      row.item.status == 'ثبت استعلام' &&
                      row.item.assigneeId == currentUserId
                    "
                    target="_blank"
                    role="button"
                    >ثبت استعلام</a
                  >&nbsp;
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'salesManager' ||
                        role == 'Manager' ||
                        role == 'tradeHead') &&
                      row.item.status == 'در انتظار بررسی فنی'
                    "
                    target="_blank"
                    role="button"
                    >بررسی فنی</a
                  >&nbsp;
                  <a
                    class="btn btn-success mr-1 mt-1"
                    :href="
                      '/' +
                      role +
                      '/query/' +
                      row.item.customerId +
                      '/' +
                      row.item.id
                    "
                    v-if="
                      (role == 'ceo' || role == 'Manager') &&
                      row.item.status == 'آماده برای امضا'
                    "
                    target="_blank"
                    role="button"
                    >بررسی نهایی و امضا</a
                  >&nbsp;
                </div>
              </template>

              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="orders.filter((x) => x.status == item).length"
              :per-page="perPage"
              aria-controls="orderByStatus"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card>

    <v-dialog v-model="followDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>توضیحات برای پرونده استعلام {{ currentOrder.code }}</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container>
            <p>
              همکار گرامی لطفا توضیحات پیگیری خود و همچنین فایل مربوطه را (در
              صورت وجود) وارد کنید
            </p>
            <div class="mb-2">
              <vue-ckeditor
                v-model="content"
                :config="config"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
            <b-form-group label="بارگذاری فایل:">
              <b-form-file
                :state="Boolean(file)"
                @input="upload(file)"
                v-model="file"
                browse-text="آپلود"
                placeholder="فایل مربوطه را آپلود کنید"
                accept="*"
              ></b-form-file>
            </b-form-group>
            <br />
            <b-progress
              v-if="myFile.showProgress"
              :value="myFile.uploadPercentage"
              :max="max"
              show-progress
              :animated="myFile.striped"
              :variant="myFile.variant"
            ></b-progress>
            <v-row>
              <br />
              <div v-if="myFile.isUploaded" color="green" class="mt-3">
                فایل با موفقیت آپلود شد.
              </div>
              <br />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeModalFollow()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="submitFollowing()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="followCustomerDialog" max-width="700px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>ارسال تعیین قیمت {{ currentOrder.code }} به مشتری</h4>
        </v-card-title>
        <v-card-text class="pb-0 pt-3 px-3">
          <v-container>
            <b-card style="border: 0" class="mb-0">
              <b-card>
                <v-row class="mb-3">
                  <v-col cols="12">
                    <a
                      class="btn btn-dark mr-1 mt-1"
                      :href="
                        '/' +
                        role +
                        '/printPreview/' +
                        'full/' +
                        currentOrder.id
                      "
                      target="_blank"
                      role="button"
                      >نسخه چاپی استعلام</a
                    >
                  </v-col>
                </v-row>
                <p>
                  همکار گرامی لطفا توضیحات پاسخ مشتری و همچنین فایل مربوطه را
                  (در صورت وجود) وارد کنید:
                </p>
                <div>
                  <vue-ckeditor
                    v-model="followContent"
                    :config="config"
                    @blur="onBlur($event)"
                    @focus="onFocus($event)"
                    @contentDom="onContentDom($event)"
                    @dialogDefinition="onDialogDefinition($event)"
                    @fileUploadRequest="onFileUploadRequest($event)"
                    @fileUploadResponse="onFileUploadResponse($event)"
                  />
                </div>
                <hr />
                <b-form-group label="بارگذاری فایل:">
                  <b-form-file
                    :state="Boolean(file)"
                    @input="upload(file)"
                    v-model="file"
                    browse-text="آپلود"
                    placeholder="فایل مربوطه را آپلود کنید"
                    accept="*"
                  ></b-form-file>
                </b-form-group>
                <br />
                <b-progress
                  v-if="myFile.showProgress"
                  :value="myFile.uploadPercentage"
                  :max="max"
                  show-progress
                  :animated="myFile.striped"
                  :variant="myFile.variant"
                ></b-progress>
                <v-row>
                  <br />
                  <div v-if="myFile.isUploaded" color="green" class="mt-3">
                    فایل با موفقیت آپلود شد.
                  </div>
                  <br />
                </v-row>

                <v-select
                  :items="sendMethods"
                  v-model="sendMethod"
                  label="روش ارسال استعلام"
                  outlined
                  dense
                ></v-select>
              </b-card>
            </b-card>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeModalCustomer()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="sendPrice()"> ارسال</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rejectDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>دلیل رد استعلام {{ currentOrder.code }}</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container>
            <p>دلیل رد استعلام را وارد کنید.</p>
            <div class="mb-2">
              <vue-ckeditor
                v-model="rejectReason"
                :config="config"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="rejectDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="submitRejectReason()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <b-modal
      id="sendtoFactory"
      ref="sendtoFactory"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>ارسال سفارش {{ selectedRequest.code }} به کارخانه</h4>
      </template>
      <template v-slot:modal-footer>
        <v-row>
          <v-col cols="1"></v-col>
          <v-col cols="10">
            <b-button variant="primary" size="lg" @click="submitFactoryModal()"
              >ارسال</b-button
            >
            <b-button
              variant="danger"
              size="lg"
              @click="closeFactoryModal()"
              class="ml-2"
              >لغو</b-button
            >
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
      </template>
      <b-card style="border: 0" class="my-0">
        <p>لطفا به منظور ارسال سفارش به کارخانه، موارد زیر را پر کنید:</p>

        <b-card class="shadow p-3 mb-5 bg-white rounded" style="border: 0">
          <b-form-group label="کد سفارش">
            <b-input v-model="factory.code" />
          </b-form-group>
          <b-form-group label="تاریخ تحویل سفارش">
            <date-picker
              v-model="factory.deliveryDate"
              :editable="true"
            ></date-picker>
          </b-form-group>
        </b-card>
      </b-card>
    </b-modal>

    <router-view></router-view>
    <div v-show="false" :id="tableType">
      <h3 style="float: right">{{ selectedStatus }}</h3>
      <b-table :items="computedTableItems" :fields="printFields">
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import router from "../router";

import VueCkeditor from "vue-ckeditor2";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    VueCkeditor,
  },
  data: function () {
    return {
      tableType: "",
      selectedStatus: "",
      printInvoice: {},
      gettingReceipt: false,
      guide: false,
      userName: "",
      followContent: "",
      getContent: "",
      factory: new Object({
        code: "",
        dueDate: "",
      }),
      moment: moment,
      rejectReason: "",
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      uploadedFiles: [],
      currentOrder: {},
      filter: null,
      fields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "شماره پرونده" },
        { key: "requestId", label: "کد درخواست" },
        // { key: 'subject', label: 'عنوان استعلام' },
        { key: "customerName", label: "نام مشتری" },
        { key: "assigneeName", label: "کارشناس بازرگانی" },
        { key: "contactName", label: "نماینده مشتری" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      printFields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "شماره پرونده" },
        { key: "requestId", label: "کد درخواست" },
        { key: "customerName", label: "نام مشتری" },
        { key: "assigneeName", label: "کارشناس بازرگانی" },
        { key: "contactName", label: "نماینده مشتری" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "status", label: "وضعیت" },
      ],
      ExcelFields: [
        { field: "code", label: "شماره پرونده" },
        { field: "requestId", label: "کد درخواست" },
        { field: "customerName", label: "نام مشتری" },
        { field: "assigneeName", label: "کارشناس بازرگانی" },
        { key: "contactName", label: "نماینده مشتری" },
        { field: "registerDate", label: "تاریخ ثبت" },
        { field: "status", label: "وضعیت" },
      ],
      response: "none",
      responses: [
        {
          value: "none",
          text: "پاسخی دریافت نشده است",
          status: "در انتظار نظر مشتری",
        },
        {
          value: "yes",
          text: "با تعیین قیمت موافقم",
          status: "تایید تعیین قیمت توسط مشتری",
        },
        {
          value: "no",
          text: "با تعیین قیمت مخالفم",
          status: "رد تعیین قیمت توسط مشتری",
        },
        {
          value: "revision",
          text: "تعیین قیمت نیاز به بازبینی دارد",
          status: "بازبینی تعیین قیمت",
        },
      ],
      statusOptions: [
        { value: "ثبت استعلام", text: "ثبت استعلام" },
        { value: "در انتظار بررسی فنی", text: "در انتظار بررسی فنی" },
        {
          value: "تعیین قیمت توسط مدیر عامل",
          text: "تعیین قیمت توسط مدیر عامل",
        },
        {
          value: "بررسی تعیین قیمت توسط مدیر فروش",
          text: "بررسی تعیین قیمت توسط مدیر فروش",
        },
        { value: "آماده برای امضا", text: "آماده برای امضا توسط مدیر عامل" },
        {
          value: "اعلام تعیین قیمت به مشتری",
          text: "اعلام تعیین قیمت به مشتری",
        },
      ],
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      TotalRows: 1,
      striped: true,
      uniqueValues: [],
      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      sendMethod: "",
      sendMethods: [
        { value: "packet", text: "پاکت دربسته" },
        { value: "email", text: "ایمیل" },
        { value: "fax", text: "فاکس" },
        { value: "whatsapp", text: "واتساپ" },
        { value: "other", text: "سایر روش‌ها (در توضیحات ذکر شود)" },
      ],
      role: "",
      currentUserId: "",
      followDialog: false,
      getCustomerDialog: false,
      followCustomerDialog: false,
      rejectDialog: false,
      orders: [],
      statuses: [
        "ثبت استعلام",
        "در انتظار بررسی فنی",
        "تعیین قیمت توسط مدیر عامل",
        "بررسی تعیین قیمت توسط مدیر فروش",
        "آماده برای امضا",
        "اعلام تعیین قیمت به مشتری",
      ],
    };
  },

  computed: {
    computedTableItems() {
      if (this.tableType == "ordersTable") {
        return this.orders;
      } else if (this.tableType == "myorders") {
        return this.orders.filter((x) => x.assigneeName == userName);
      } else if (this.tableType == "revisionOrders") {
        return this.orders.filter((x) => x.revision > 0);
      } else if (this.tableType == "tabs") {
        return this.orders.filter((x) => x.status == this.selectedStatus);
      }
    },
  },

  methods: {
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/getall",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          setTimeout(() => {
            this.printReceipt();
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt(type, item) {
      this.tableType = type;
      this.selectedStatus = item;
      //printing receipt
      var myWindow = window.open("#", this.tableType, "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title> </title>"
      );
      setTimeout(() => {
        myWindow.document.write("</head><body>");
        myWindow.document.write(
          document.getElementById(this.tableType).innerHTML
        );
        myWindow.document.write("</body></html>");
        myWindow.document.close();
      }, 100);

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },

    toggleHelp() {
      this.guide = !this.guide;
    },
    printPreview(order, type) {
      this.$router.push(
        "/" + this.role + "/" + "printPreview/" + type + "/" + order.id
      );
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    assignToMe(order) {
      Axios.post(
        this.baseUrl + "/ppkpms/order/assignToMe",
        { orderId: order.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.showOrders();
            const title = (
              <div>
                <h5>تخصیص به من</h5>
                <span>.با موفقیت انجام شد</span>
              </div>
            );
            this.toast(title, "success");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    customerResponse() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/customerResponse",
        {
          orderId: this.$route.params.id,
          // targetFile:this.,
          sendMethod: this.response,
          note: this.getContent,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    removeAssignee(order) {
      Axios.post(
        this.baseUrl + "/ppkpms/order/removeAssignee",
        { orderId: order.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.showOrders();
            const title = (
              <div>
                <h5>حذف مجری</h5>
                <span>.مجری با موفقیت حذف شد</span>
              </div>
            );
            this.toast(title, "success");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    showOrders() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/orders/getActive",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.orders = res.data;
            this.TotalRows = this.orders.length;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    // updateOrders() {
    //   Axios.post(
    //     this.baseUrl + "/ppkpms/orders/getAll",
    //     {},
    //     {
    //       headers: {
    //         Authorization: "Bearer: " + localStorage.getItem("token"),
    //       },
    //     }
    //   )
    //     .then((res) => {
    //       if (res.status == 200) {
    //         this.orders = res.data;
    //         this.TotalRows = this.orders.length;
    //       } else {
    //         this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
    //       }
    //     })
    //     .catch((err) => {
    //       this.toast(err.response.data, "error");
    //     });
    // },
    showRejectModal(order) {
      this.rejectDialog = true;
      this.currentOrder = order;
      this.rejectReason = "";
    },
    submitRejectReason() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/rejectOrder",
        {
          orderId: this.currentOrder.id,
          note: this.rejectReason,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.rejectDialog = false;
            this.rejectReason = "";
            this.showOrders();
            this.toast("وضعیت استعلام به عدم تغییر داده شد", "success");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    showModalFollow(order) {
      this.currentOrder = order;
      this.followDialog = true;
      this.content = "";
      this.file = [];
      this.uploadedFiles = [];
      this.myFile = new Object({
        uploadPercentage: 0,
      });
    },
    closeModalFollow() {
      this.currentOrder = {};
      this.followDialog = false;
    },
    submitFollowing() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/attachFile",
        {
          orderId: this.currentOrder.id,
          file: JSON.stringify(this.uploadedFiles),
          note: this.content,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.vLoading = false;
            this.followDialog = false;
            this.uploadedFiles = [];
            this.file = [];
            this.myFile = new Object({
              uploadPercentage: 0,
            });
            this.content = "";
            this.showOrders();
            this.toast(res.data, "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    openModalCustomer(order) {
      this.currentOrder = order;
      this.followCustomerDialog = true;
      this.followContent = "";
      this.sendMethod = "";
      this.file = [];
      this.uploadedFiles = [];
      this.myFile = new Object({
        uploadPercentage: 0,
      });
    },
    closeModalCustomer() {
      this.currentOrder = {};
      this.followCustomerDialog = false;
    },
    sendPrice() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/sendPrice",
        {
          orderId: this.currentOrder.id,
          targetFile: JSON.stringify(this.uploadedFiles),
          sendMethod: this.sendMethod,
          note: this.followContent,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.followCustomerDialog = false;
            this.followContent = "";
            this.sendMethod = "";
            this.file = [];
            this.uploadedFiles = [];
            this.myFile = new Object({
              uploadPercentage: 0,
            });
            this.toast("استعلام برای مشتری ارسال شد", "success");
            this.showOrders();
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    showModalFollowPrice(order) {
      this.currentOrder = order;
      this.$refs["modalFollowPrice"].show();
    },
    closeModalFollowPrice() {
      this.currentOrder = {};
      this.$refs["modalFollowPrice"].hide();
    },
    showModalFollowCustomer(order) {
      this.currentOrder = order;
      this.$refs["modalFollowCustomer"].show();
    },
    closeModalFollowCustomer() {
      this.currentOrder = {};
      this.$refs["modalFollowCustomer"].hide();
    },
    showRejectReason(item) {
      this.selectedRequest = item;
      this.$refs["rejectReason"].show();
    },
    closeRejectReason() {
      this.rejectReason = "";
      this.selectedRequest = "";
      this.$refs["rejectReason"].hide();
    },
    factoryModal(item) {
      this.selectedRequest = item;
      this.$refs["sendtoFactory"].show();
    },
    closeFactoryModal() {
      this.selectedRequest = {};
      this.$refs["sendtoFactory"].hide();
    },
    submitFactoryModal() {},
    upload(file) {
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);

      Axios.post(this.baseUrl + "/ppkpms/uploads/private", formData, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
        onUploadProgress: ((progressEvent) => {
          this.myFile.uploadPercentage =
            Math.round((progressEvent.loaded * 100) / progressEvent.total) - 1;
        }).bind(this),
      })
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.uploadedFiles = d.data[0];
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
  },

  mounted() {
    // this.getTableInfo()

    this.showOrders();
    this.role = window.localStorage.getItem("role");
    this.userName = window.localStorage.getItem("name");
    this.currentUserId = window.localStorage.getItem("userId");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
.nav-pills {
  padding: 10px !important;
}
</style>
